/* Cookie banner + preferences (snippets/hn-consent-banner.liquid).
 *
 * US opt-out model (K&L Gates report, 2026-09-22): trackers may run until a
 * visitor objects. The banner shows once to visitors in BANNER_REGIONS; the
 * footer's "Your Privacy Choices" link opens the preferences anywhere; a
 * Global Privacy Control signal counts as Reject All everywhere.
 *
 * A choice is (1) given to Shopify's Customer Privacy API, which switches
 * Shopify pixels and checkout, (2) mirrored in localStorage `hn_consent`,
 * which snippets/hn-consent-core reads before the theme loads its own
 * trackers, and (3) logged to HappyInnovations (privacy.consent_events) as
 * the audit trail. Turning a category off clears its known cookies and
 * reloads the page once, so nothing loaded before the choice keeps running.
 *
 * Keep this file identical in Happy Nuts and Happy Curves.
 */
(function () {
  'use strict';

  /* States where the banner shows on landing (Shopify region codes). The
     all-party-consent wiretap states where pixel claims are filed; confirm
     changes with counsel. */
  var BANNER_REGIONS = ['USCA', 'USPA', 'USWA', 'USMA', 'USFL', 'USMD'];

  /* Which banner text was on screen. Bump whenever the text changes. */
  var BANNER_VERSION = '2026-10-25';

  var KEY = 'hn_consent';
  var PREVIEW_KEY = 'hn_consent_preview';

  /* Known tracking cookies and storage, cleared when their category is turned
     off. Shopify's own cookies are never touched (Shopify forbids it). */
  var ANALYTICS = {
    cookies: [/^_ga/, /^_gid$/, /^_gat/, /^_clck$/, /^_clsk$/],
    storage: [/^hn_telemetry:/, /^hi_exp:src$/]
  };
  var MARKETING = {
    cookies: [
      /^_gcl_/, /^_fbp$/, /^_fbc$/, /^_ttp$/, /^ttcsid/, /^_scid/, /^_sctr$/,
      /^_pin_unauth$/, /^_pinterest_/, /^_rdt_/, /^_uet/, /^__kla_id$/,
      /^_ax/, /^ax_visitor$/, /^ugc_vid_/, /^dt_id$/, /^GROMMET_USER_UID$/,
      /^_mp_/, /^_mplidl$/, /^_mpxl_guid$/, /^_ldid$/, /^_lmid$/, /^_lst$/
    ],
    storage: [/^TriplePixel/, /^_alwrt/, /^il_/, /^_mp_/]
  };

  var W = window;
  var D = document;
  var consent = W.HnConsent;
  var banner = D.getElementById('hn-consent-banner');
  var prefs = D.getElementById('hn-consent-prefs');
  if (!consent || !banner || !prefs || W.HnConsentBanner) return;

  var analyticsSwitch = D.getElementById('hn-consent-analytics');
  var marketingSwitch = D.getElementById('hn-consent-marketing');
  var gpcNote = D.getElementById('hn-consent-gpc');

  var config = {};
  try {
    config = JSON.parse(D.getElementById('hn-consent-config').textContent) || {};
  } catch (e) {}

  var privacy = null;
  var inRegion = false;

  function uuid() {
    try {
      if (W.crypto && W.crypto.randomUUID) return W.crypto.randomUUID();
    } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 3) | 8).toString(16);
    });
  }

  function readChoice() {
    try {
      var parsed = JSON.parse(W.localStorage.getItem(KEY) || 'null');
      if (parsed && parsed.v === 1 && typeof parsed.a === 'boolean' && typeof parsed.m === 'boolean') return parsed;
    } catch (e) {}
    return null;
  }

  function saveChoice(analytics, marketing, source) {
    var previous = readChoice();
    var choice = {
      v: 1,
      id: (previous && previous.id) || uuid(),
      a: analytics,
      m: marketing,
      src: source,
      at: new Date().toISOString()
    };
    try {
      W.localStorage.setItem(KEY, JSON.stringify(choice));
    } catch (e) {}
    return choice;
  }

  function region() {
    try {
      return (privacy && typeof privacy.getRegion === 'function' && privacy.getRegion()) || '';
    } catch (e) {
      return '';
    }
  }

  function shopifyConsentId() {
    try {
      var id = privacy && typeof privacy.consentId === 'function' ? privacy.consentId() : null;
      return id ? String(id).slice(0, 200) : null;
    } catch (e) {
      return null;
    }
  }

  /* Shopify's purposes: preferences are strictly necessary here (language,
     currency); sale of data follows advertising. */
  function tellShopify(analytics, marketing, done) {
    if (typeof consent.klaviyo === 'function') consent.klaviyo(marketing);
    var called = false;
    function finish() {
      if (called) return;
      called = true;
      if (done) done();
    }
    try {
      if (privacy && typeof privacy.setTrackingConsent === 'function') {
        privacy.setTrackingConsent(
          { analytics: analytics, marketing: marketing, preferences: true, sale_of_data: marketing },
          finish
        );
        W.setTimeout(finish, 1500);
        return;
      }
    } catch (e) {}
    finish();
  }

  /* The audit record. sendBeacon survives the reload that follows a Reject. */
  function record(action, choice) {
    if (!config.endpoint || !config.store) return;
    var body = JSON.stringify({
      store: config.store,
      event_id: uuid(),
      consent_subject_id: choice.id,
      shopify_consent_id: shopifyConsentId(),
      action: action,
      analytics: choice.a,
      marketing: choice.m,
      preferences: true,
      sale_of_data: choice.m,
      gpc: !!consent.gpc,
      region: region() || null,
      banner_shown: inRegion,
      banner_version: BANNER_VERSION,
      page_path: W.location.pathname,
      client_at: new Date().toISOString()
    });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(config.endpoint, body)) return;
    } catch (e) {}
    try {
      W.fetch(config.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: body,
        keepalive: true,
        credentials: 'omit'
      });
    } catch (e) {}
  }

  function matches(name, patterns) {
    for (var i = 0; i < patterns.length; i++) if (patterns[i].test(name)) return true;
    return false;
  }

  function clearGroup(group) {
    var host = W.location.hostname;
    var parts = host.split('.');
    var domains = ['', host, '.' + host];
    if (parts.length > 2) domains.push('.' + parts.slice(-2).join('.'));
    var cookies = D.cookie ? D.cookie.split(';') : [];
    for (var i = 0; i < cookies.length; i++) {
      var name = cookies[i].split('=')[0].trim();
      if (!name || !matches(name, group.cookies)) continue;
      for (var d = 0; d < domains.length; d++) {
        D.cookie = name + '=; Max-Age=0; path=/' + (domains[d] ? '; domain=' + domains[d] : '');
      }
    }
    try {
      for (var k = W.localStorage.length - 1; k >= 0; k--) {
        var key = W.localStorage.key(k);
        if (key && matches(key, group.storage)) W.localStorage.removeItem(key);
      }
    } catch (e) {}
  }

  function showBanner() {
    banner.hidden = false;
    banner.classList.add('is-entering');
    W.requestAnimationFrame(function () {
      W.requestAnimationFrame(function () {
        banner.classList.remove('is-entering');
      });
    });
  }

  function hideBanner() {
    banner.hidden = true;
  }

  function currentChoice() {
    var stored = readChoice();
    return stored ? { a: stored.a, m: stored.m } : { a: consent.analytics(), m: consent.marketing() };
  }

  function openPrefs() {
    var gpc = !!consent.gpc;
    var now = gpc ? { a: false, m: false } : currentChoice();
    analyticsSwitch.checked = now.a;
    marketingSwitch.checked = now.m;
    analyticsSwitch.disabled = gpc;
    marketingSwitch.disabled = gpc;
    gpcNote.hidden = !gpc;
    var locked = prefs.querySelectorAll('[data-consent-action="accept_all"], [data-consent-action="save_preferences"]');
    for (var i = 0; i < locked.length; i++) locked[i].disabled = gpc;
    if (typeof prefs.showModal === 'function') {
      if (!prefs.open) prefs.showModal();
    } else {
      prefs.setAttribute('open', '');
    }
  }

  function closePrefs() {
    if (typeof prefs.close === 'function' && prefs.open) prefs.close();
    else prefs.removeAttribute('open');
  }

  /* A decision from the banner or the preferences. Turning anything off
     clears that category's cookies and reloads once. */
  function decide(action, analytics, marketing) {
    var before = currentChoice();
    var choice = saveChoice(analytics, marketing, action);
    record(action, choice);
    var lowered = (before.a && !analytics) || (before.m && !marketing);
    tellShopify(analytics, marketing, function () {
      if (lowered) {
        if (!analytics) clearGroup(ANALYTICS);
        if (!marketing) clearGroup(MARKETING);
        W.location.reload();
        return;
      }
      hideBanner();
      closePrefs();
    });
  }

  /* Closing the banner is not a choice: nothing changes (US opt-out), and
     the banner does not come back. */
  function dismiss() {
    var now = currentChoice();
    record('dismiss', saveChoice(now.a, now.m, 'dismiss'));
    hideBanner();
  }

  function onAction(event) {
    var button = event.target.closest && event.target.closest('[data-consent-action]');
    if (!button || button.disabled) return;
    var action = button.getAttribute('data-consent-action');
    if (action === 'accept_all') decide('accept_all', true, true);
    else if (action === 'reject_all') decide('reject_all', false, false);
    else if (action === 'save_preferences') decide('save_preferences', analyticsSwitch.checked, marketingSwitch.checked);
    else if (action === 'manage') openPrefs();
    else if (action === 'dismiss') dismiss();
    else if (action === 'close') closePrefs();
  }

  banner.addEventListener('click', onAction);
  prefs.addEventListener('click', function (event) {
    if (event.target === prefs) return closePrefs(); /* backdrop */
    onAction(event);
  });

  /* "Your Privacy Choices" (footer menus) opens the preferences instead of
     Shopify's page; modified clicks and no-JS visitors still get the page. */
  D.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href*="/pages/data-sharing-opt-out"]');
    if (!link) return;
    event.preventDefault();
    openPrefs();
  });

  W.HnConsentBanner = { open: openPrefs, version: BANNER_VERSION, regions: BANNER_REGIONS.slice() };

  /* Clear the cookies of every category that is off, on each page and again
     on leaving it. Tags can still write in the moment before Shopify hears
     the choice, or while a page unloads; this keeps those writes from
     lasting. */
  function sweep() {
    var now = consent.gpc ? { a: false, m: false } : currentChoice();
    if (!now.a) clearGroup(ANALYTICS);
    if (!now.m) clearGroup(MARKETING);
  }
  sweep();
  W.addEventListener('pagehide', sweep);

  /* ?hn_consent_preview=1 shows the banner for this browser session whatever
     the region or stored choice (design review); =0 ends it. */
  var preview = false;
  try {
    var flag = /[?&]hn_consent_preview=([01])/.exec(W.location.search);
    if (flag) W.sessionStorage.setItem(PREVIEW_KEY, flag[1]);
    preview = W.sessionStorage.getItem(PREVIEW_KEY) === '1';
  } catch (e) {}

  /* True when Shopify's record has a category on that the visitor turned
     off, or off that the visitor allowed. */
  function shopifyDisagrees(analytics, marketing) {
    try {
      var now = privacy.currentVisitorConsent();
      return (now.analytics === 'no') === analytics || (now.marketing === 'no') === marketing;
    } catch (e) {
      return false;
    }
  }

  function start() {
    privacy = (W.Shopify && W.Shopify.customerPrivacy) || null;
    inRegion = BANNER_REGIONS.indexOf(region()) !== -1;
    var stored = readChoice();

    if (consent.gpc) {
      /* Recorded once per browser: the signal is the visitor's choice. */
      if (!stored || stored.src !== 'gpc' || stored.a || stored.m) {
        var choice = saveChoice(false, false, 'gpc');
        record('gpc', choice);
        tellShopify(false, false, sweep);
        /* Shopify can drop the first choice saved for a brand-new visitor
           (about half the time on both stores, October 2026); a second
           save moments later sticks. */
        W.setTimeout(function () {
          tellShopify(false, false, sweep);
        }, 1500);
      } else if (shopifyDisagrees(false, false)) tellShopify(false, false, sweep);
      if (preview) showBanner();
      return;
    }

    /* Shopify lost the choice (cookies cleared, or the save above was
       dropped) but the visitor's choice stands. */
    if (stored && shopifyDisagrees(stored.a, stored.m)) tellShopify(stored.a, stored.m, sweep);

    if (preview || (!stored && inRegion)) showBanner();
  }

  var started = false;
  function startOnce() {
    if (started) return;
    started = true;
    start();
  }
  if (W.Shopify && W.Shopify.customerPrivacy) startOnce();
  else if (W.Shopify && typeof W.Shopify.loadFeatures === 'function') {
    try {
      W.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], startOnce);
    } catch (e) {
      startOnce();
    }
    W.setTimeout(startOnce, 4000);
  } else startOnce();
})();
